import getAdminObjectData from '../getAdminObjectData';
import { infoNotification } from '../../../shared/store/notificationActions';

import readXlsxFileAsJson from '../../../shared/xlsxImport/readXlsxFileAsJson';
import emptyRowsTrimmer from '../../../shared/xlsxImport/processors/emptyRowsTrimmer.processor';

import {
  CHANGE_SELECTED_ADMIN_OBJECT,
  STOP_FETCHING_ADMIN_OBJECT,
} from './types';

export const changeSelectedAdminObject = (adminObject, period) => async dispatch => {
  dispatch({
    type: CHANGE_SELECTED_ADMIN_OBJECT,
    selectedAdminObject: adminObject,
  });

  await dispatch(getAdminObjectData(adminObject).fetchAction({ periodName: period.name }));

  dispatch({
    type: STOP_FETCHING_ADMIN_OBJECT,
  });
};

export const saveAdminObject = (adminObject, file, period, context = {}) => async dispatch => {
  const adminObjectData = getAdminObjectData(adminObject);
  const preprocessors = adminObjectData.preprocessors
    ? adminObjectData.preprocessors
    : [];

  const jsonAdminObject = await readXlsxFileAsJson({
    file,
    fieldMappings: typeof adminObjectData.fieldMappings === 'function'
      ? adminObjectData.fieldMappings(context)
      : adminObjectData.fieldMappings,
    sheetName: adminObjectData.fileName,
    preprocessors: [emptyRowsTrimmer, ...preprocessors],
  });

  dispatch(infoNotification('Import process started, check corresponding admin pages to see the uploaded data'));
  await dispatch(adminObjectData.importAction(jsonAdminObject, period));
};
